export default __webpack_public_path__ + "static/media/bullet-true-green.c64e71f8.svg";